export const getReservationCmsPayload = (responseData: any) =>
  responseData?.data ?? responseData;

export const getResponsePayload = (response: any) => {
  const responseData = response?.data ?? response;
  return getReservationCmsPayload(responseData);
};

export const getFirstMediaUrl = (item: any) => {
  const media = item?.media;
  const firstMedia = Array.isArray(media) ? media[0] : media;

  return firstMedia?.url ?? firstMedia?.src ?? firstMedia?.path ?? firstMedia;
};

const getMediaItemUrl = (mediaItem: any) =>
  mediaItem?.url ?? mediaItem?.src ?? mediaItem?.path ?? mediaItem;

export const getMediaUrls = (item: any) => {
  const media = Array.isArray(item?.media)
    ? item.media
    : item?.media
    ? [item.media]
    : [];
  const images = Array.isArray(item?.images)
    ? item.images
    : item?.images
    ? [item.images]
    : [];

  return [...media, ...images]
    .map(getMediaItemUrl)
    .filter(Boolean)
    .filter(
      (imageUrl, index, imageUrls) => imageUrls.indexOf(imageUrl) === index,
    );
};

export const getCuisineTypes = (item: any) => {
  const cuisineTypes = item?.cusineType ?? item?.cuisineType ?? item?.cuisines;

  return Array.isArray(cuisineTypes)
    ? cuisineTypes.filter(Boolean)
    : cuisineTypes
    ? [cuisineTypes]
    : [];
};

export const formatReservationPriceRange = (item: any) => {
  const priceFrom = item?.priceRangeFrom;
  const priceTo = item?.priceRangeTo;
  const currencyCode = item?.currencyCode ?? '';
  const formatPrice = (value: any) => {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) return value;

    return new Intl.NumberFormat('vi-VN').format(numericValue);
  };

  if (priceFrom && priceTo) {
    return `${formatPrice(priceFrom)} - ${formatPrice(
      priceTo,
    )} ${currencyCode}`.trim();
  }

  if (priceFrom) return `>= ${formatPrice(priceFrom)} ${currencyCode}`.trim();
  if (priceTo) return `<= ${formatPrice(priceTo)} ${currencyCode}`.trim();

  return item?.priceRangeKey ?? item?.priceRange ?? '';
};

export const mergeVariantCmsItem = (variant: any, cmsItem: any) => {
  if (!cmsItem) return variant;

  return {
    ...variant,
    cmsItem,
    priceRangeFrom: cmsItem?.priceRangeFrom ?? variant?.priceRangeFrom,
    priceRangeTo: cmsItem?.priceRangeTo ?? variant?.priceRangeTo,
    currencyCode: cmsItem?.currencyCode ?? variant?.currencyCode,
    cusineType: getCuisineTypes(cmsItem),
    imageUrl: getFirstMediaUrl(cmsItem) ?? variant?.imageUrl,
    media: cmsItem?.media ?? variant?.media,
    menu: cmsItem?.menu ?? variant?.menu,
    description:
      cmsItem?.description ?? cmsItem?.shortDescription ?? variant?.description,
    priceRangeKey: formatReservationPriceRange({
      ...variant,
      ...cmsItem,
    }),
  };
};
